module.exports = __webpack_public_path__ + "img/0Q3B5909-12_H_Black.a0c70626.jpg";